import { FC } from 'react';
import { SkeletonWrapper } from '~/skeleton/common/skeleton-wrapper';
import {
  ArticleAuthorSkeleton,
  ArticleCommentSkeleton,
  ArticleContentSkeleton,
  ArticleLargeImageSkeleton,
  ArticleTitleSkeleton,
} from '~/skeleton/article/component';
import { ArticleCardSkeleton } from '~/skeleton/common/article-card';
import { SkeletonScanline } from '~/skeleton/common/skeleton-scanline';
import { CampaignSkeleton } from '~/skeleton/common/campaign';

export const ArticleSkeleton: FC = () => {
  return (
    <SkeletonWrapper fix>
      <ArticleAuthorSkeleton />
      <ArticleLargeImageSkeleton />
      <ArticleTitleSkeleton />
      <ArticleContentSkeleton />
      <ArticleCommentSkeleton />
      <CampaignSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};

export const ArticleBodySkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ArticleCommentSkeleton />
      <CampaignSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};

export const ArticleRecommendSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};
